import { Box, Button, IconButton, MenuItem, Paper, Select, Tooltip, Typography } from "@mui/material";
import { AddCircleOutline, ArrowBack, ArrowForward, FilterAlt, North,Sort,South, Task } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { APICallStatus, Priority, ToDo, ToDoStatus } from "../../Types/UnitFeatureTypes";
import { useDispatch, useSelector } from "react-redux";
import BuildToDoTable from "../BuildTables/BuildToDoTable";
import TaskDialog from "../CreateFeatures/TaskDialog";
import { useAuth } from "../../context/authContext";
import { createToDoAPIStatus, fetchToDo, fetchToDoCount } from "../../Redux/selectors";
import { Actions } from "../../Redux/Reducer/ToDo";
import { FIXED_PAGE_ROWS } from "../../Utils/Constants";
import { useApp } from "../../context/appContext";
import PageNavigation from "../CommonComponents/PageNavigation";
import ViewTableHeader from "../CommonComponents/ViewTableHeader";

const ViewToDoTable: React.FC = () => {

    const [sortDirection, setSortDirection] = useState<boolean>(true);
    const [sortColumn, setSortColumn] = useState<string>('created_on');
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const allTasks = useSelector(fetchToDo) as ToDo[];
    const allTasksCount = useSelector(fetchToDoCount) as string;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [item, setItem] = useState<ToDo[]>([]);
    const [addTask, setAddTask] = useState<boolean>(false);
    const createTaskApiStatus = useSelector(createToDoAPIStatus);
    const dispatch = useDispatch();
    const {user} = useAuth();
    const {setSnackbar} = useApp();
    const [formData, setFormData] = useState<ToDo>({
        id: -1,
        title: '',
        description: '',
        priority: Priority.LOW,
        due_date: new Date(),
        created_on: new Date(),
        status: ToDoStatus.PENDING,
        created_user_id: user.id,
    });

    useEffect(() => {
        if (createTaskApiStatus === APICallStatus.SUCCESS) {
            setSnackbar(true, 'Task Created Successfully', 'success');
            dispatch(Actions.fetchToDo.toDoActions.request({offset: (currentPage)*FIXED_PAGE_ROWS, sortColumn, sortDirection: sortDirection ? 'asc' : 'desc'}));
        } else if (createTaskApiStatus === APICallStatus.FAILURE) {
            setSnackbar(true, 'Failed to Create Task', 'error');
        }
        if (createTaskApiStatus === APICallStatus.SUCCESS || createTaskApiStatus === APICallStatus.FAILURE) {
            dispatch(Actions.todo.resetStatusRequestAction());
        }
    }, [createTaskApiStatus]);

    useEffect(() => {
        dispatch(Actions.fetchToDo.toDoActions.request({offset: (currentPage)*FIXED_PAGE_ROWS, sortColumn, sortDirection: sortDirection ? 'asc' : 'desc'}))
    },[currentPage, allTasksCount, sortDirection, sortColumn]);

    useEffect(() => {
        setItem(allTasks);
    }, [allTasks]);

    useEffect(() => {
        const totalRequest = Number(allTasksCount);
        const pages = Math.ceil(totalRequest/FIXED_PAGE_ROWS);
        setTotalPages(pages);
    }, [allTasksCount]);

    if (!item) {
        return (
            <Typography variant="h5" color="textSecondary">No Tasks Available</Typography>
        )
    }

    const validateForm = () => {
        let errors: { [key: string]: string } = {};
        if (formData.title === '') {
            errors.title = 'Title is required';
        }
        if (formData.description === '') {
            errors.description = 'Description is required';
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }
    const handleAddTask = () => {
        if (validateForm()) {
            dispatch(Actions.todo.createTaskRequestAction.request({toDoData: formData}));
            // setAddTask(false);
        } 
    }

    return (
        <>
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            <ViewTableHeader
                title="Task List"
                icon={Task}
                handleAdd={() => setAddTask(true)}
                addText="Add Task"
                sortColumn={sortColumn}
                setSortColumn={setSortColumn}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                sortValues={[
                    { value: 'created_on', label: 'Create Date'},
                    { value: 'title', label: 'Name'},
                    { value: 'due_date', label: 'Due Date'},
                    { value: 'priority', label: 'Priority'},
                ]}
            />
            <BuildToDoTable item={item} />
            <PageNavigation currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>
        </Paper>
        <TaskDialog 
            open={addTask} 
            displayName="Add Task" 
            onCloseFunc={() => setAddTask(false)}
            actionOne={{label: "Cancel", color: "error", func: () => setAddTask(false)}}
            actionTwo={{label: "Add", color: "primary", func: handleAddTask}}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
        />
        </>
    )
}

export default ViewToDoTable;